var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 259 67",
    style: {
      enableBackground: "new 0 0 259 67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004A8B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "125.4,29.8 116.3,55.1 123.5,55 132.4,29.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "85.5,11.8 92.7,11.7 92.8,48.5 111.4,48.4 111.4,55.1 85.6,55.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "132.1,11.4 139,11.4 155.1,54.9 147.6,55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "152.2,11.6 159.8,11.5 168.4,43 177.2,11.4 183.4,11.3 192.3,42.9 200.7,11.4 208.2,11.4 195.7,55  189.2,55.1 180.2,24.5 171.4,55.1 164.9,55.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,11.4l13.3,0c12.4,0,20.6,8.6,20.6,21.3l0,0.5c0,12.7-8.1,21.5-20.5,21.6l-13.3,0L214.4,11.4z  M221.6,17.8l0.1,30.4l6,0c7.9,0,13.2-5.7,13.2-15l0-0.4c0-9.4-5.3-15-13.2-15L221.6,17.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,32.9h-4.2c0-8.4,6.8-15.2,15.2-15.2v4.2C26.8,21.9,21.9,26.8,21.9,32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,32.9h-4.2c0-3.6,2.9-6.5,6.5-6.5v4.2C31.6,30.6,30.6,31.6,30.6,32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,32.9H8.8c0-13.3,10.8-24,24-24v4.2C21.9,13.1,13.1,21.9,13.1,32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,32.9H0C0,14.7,14.7,0,32.9,0v4.2C17.1,4.2,4.2,17.1,4.2,32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,66.3c1.4-0.2,2.7-0.4,4-0.8V0.8c-1.3-0.3-2.7-0.6-4-0.8V66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.5,64.1c1.4-0.6,2.8-1.3,4-2V4.5c-1.3-0.8-2.6-1.4-4-2V64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,7.5v51.5c1.5-1.2,2.8-2.5,4-3.9V11.5C56.7,10.1,55.4,8.7,53.9,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,49.2c2.6-4.7,4-10.1,4-15.8s-1.5-11.1-4-15.8V49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,63.2l-3.1,3.3c1,0.1,2.1,0.2,3.1,0.2V63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,38L12.6,59.6c1.1,0.8,2.2,1.6,3.3,2.3l16.9-18V38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,50.6L20.2,64c1.3,0.6,2.7,1,4.2,1.4l8.5-9V50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,37.3L6.5,53.4c0.8,1.1,1.7,2.1,2.6,3.1l18.1-19.2H21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,37.3c0,0.3,0.1,0.6,0.1,1c0.1,0.8,0.3,1.5,0.4,2.2l3-3.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,37.3l-7.8,8.3c0.5,1.3,1.2,2.6,1.8,3.9l11.4-12.2H9.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.27895a4a0f2afc98cddd7f604598a1e5.svg";
export { ForwardRef as ReactComponent };